import { regex } from 'react-admin';

export default regex(/[0-3]?[0-9]:[0-5][0-9]:00/, 'hh:mm:ss');
